export default "__VITE_ASSET__D1A6xsHx__"